module.exports = __webpack_public_path__ + "static/media/squad-armory-sub.c3bbcfbc.png";